import { Add, Close, Delete, Edit } from '@mui/icons-material';
import {
    Autocomplete,
    Button,
    IconButton,
    Modal,
    TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Alert, Snackbar } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Col, Row } from 'antd';
import ExamCover from 'components/AdminBooks/ExamCover';
import PageImagePicker from 'components/AdminBooks/PageImagePicker';
import { DeleteModal } from 'components/Dialog';
import Loading from 'components/Loading';
import Section from 'components/Section';
import dayjs from 'dayjs';
import { cloneDeep, find, get, groupBy, has, map } from 'lodash';
import moment from 'moment';
import { useStandardExams } from 'store/standardexams/selectors';
import {
    handleDeleteStandardExam,
    handleListStandardExams,
    handleUpdateStandardExams,
} from 'store/standardexams/thunks';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import { isBeforTime } from 'utils/methods/math';
import EditStandardExamLevel from './EditStandardExam';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const ListItem = styled.li`
  margin: 0px 4% 32px;
  width: calc(21%);

  @media only screen and (min-width: 600px) and (max-width: 800px) {
    margin: 0px 16px 32px;
    width: calc(50% - 32px);
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin: 0px 16px 32px;
    width: 100%;
  }
`;
const List = styled.ul`
  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  justify-content: center;
`;

const ModalContent = styled.div`
  left: 50%;
  width: 70vw;
  padding: 0px 24px;
  position: absolute;
  //   height:80vh;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
  margin-left: 5px;
  margin-top: 5px;
`;

const PaddedBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  outline: none;
  padding: 8px;
  text-align: left;
  width: 100%;
`;
//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const getMinDate = (date1, date2) => {
  if (date1 && date2) {
    return isBeforTime(date1, date2)
      ? moment(date2).add(1, 'minute').toISOString()
      : moment(date1).add(1, 'minute').toISOString();
  } else if (date1 || date2) {
    return date1
      ? moment(date1).add(1, 'minute').toISOString()
      : moment(date2).add(1, 'minute').toISOString();
  } else {
    return moment().toString();
  }
};

const EditExams = ({ open, close, data, booksAllList, exam, redirectToBook }) => {
  const [loading, setLoading] = useState(false);
  const [examData, setExamData] = useState();
  const dispatch = useDispatch();
  const onCreateOrUpdate = async () => {
    setLoading(true);
    const dt = cloneDeep(exam);
    if (examData && examData.id) {
      if(exam && Array.isArray(exam.standard_exams) && exam.standard_exams.length > 0){
      exam.standard_exams.map((e, i) => {
        if (e.id === examData.id) {
          dt.standard_exams[i] = examData;
        }
      });
    }
      await dispatch(handleUpdateStandardExams(dt));
    } else {
        const stdExams = exam?.standard_exams || [];

        let maxId = stdExams.length > 0 
            ? Math.max(...stdExams.map((o) => parseInt(o.id))) 
            : 0;
        
        if (isNaN(maxId) || maxId === -Infinity) maxId = 0;
        maxId++;
        
        dt.standard_exams = [...stdExams, { ...examData, id: maxId, order: maxId }];
        await dispatch(handleUpdateStandardExams(dt));

    }
    setLoading(false);
    close();
  };
  useEffect(() => {
    setExamData(data);
  }, [data]);
  const isDisabled =
    !get(examData, 'src') || !get(examData, 'displayName') || !get(examData, 'bookId');
  return (
    <Modal open={open} onClose={() => close()} style={{ height: '100%', width: '100%' }}>
      <ModalContent>
        <Row style={{ justifyContent: 'space-between' }}>
          <TitleText>{data ? 'Update Exam' : 'Add Exam'}</TitleText>
          <IconButton onClick={() => close()} style={{ padding: 0, marginRight: 10 }}>
            <Close color="secondary" />
          </IconButton>
        </Row>
        <ModalConfigArea>
          <Row>
            <Col xs={24} lg={12} style={{ marginBottom: 20 }}>
              <PageImagePicker
                src={get(examData, 'src')}
                path={`/exams`}
                onChange={(item) => {
                  setExamData({ ...examData, src: item.url });
                }}
                hasDescription={false}
              />
            </Col>
            <Col xs={24} lg={12} style={{ paddingLeft: 10, paddingTop: 10 }}>
              <Row justify="start" style={{ marginBottom: 20 }}>
                <TextField
                  id="displayName"
                  name="displayName"
                  label="Display name"
                  required={false}
                  InputLabelProps={{ shrink: true }}
                  type="text"
                  variant="outlined"
                  onChange={(e) => {
                    setExamData({ ...examData, displayName: e.target.value });
                  }}
                  value={get(examData, 'displayName')}
                />
              </Row>
              <Row
                gutter={[24, 24]}
                style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
                className="floatingLabelBG"
              >
                <Col span={24} style={{ paddingLeft: '0 !important' , paddingRight: '0 !important'}}>
                  <Autocomplete
                    id="bookId"
                    options={booksAllList}
                    getOptionLabel={(option) => `${option.description || ""} (${option.id || ""})`}
                    value={booksAllList.find((bk) => bk.id === get(examData, "bookId")) || null}
                    onChange={(event, newValue) => {
                      setExamData({
                        ...examData,
                        bookId: newValue ? newValue.id : "",
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Book" variant="outlined" fullWidth />
                    )}
                    fullWidth
                  />
                </Col>
              </Row>
              <Row gutter={[16, 24]} className="durDateSpc">
                <Col span={24}>
                  <DateTimePicker
                    id="StartFrom"
                    label="Start Date"
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        InputLabelProps: {
                          shrink: true,
                        },
                      },
                    }}
                    format="MM-DD-YYYY hh:mm a"
                    value={get(examData, 'startDate') ? dayjs(get(examData, 'startDate')) : dayjs()}
                    onChange={(e) => {
                      setExamData({
                        ...examData,
                        startDate: e ? e.toISOString() : null,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={[16, 24]} className="durDateSpc" style={{ marginBottom: 30 }}>
                <Col span={24}>
                  <DateTimePicker
                    id="ednFromDate"
                    label="End Date"
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        InputLabelProps: {
                          shrink: true,
                        },
                      },
                    }}
                    format="MM-DD-YYYY hh:mm a"
                    minDateTime={
                      get(examData, 'startDate')
                        ? dayjs(getMinDate(get(examData, 'startDate')))
                        : null
                    }
                    value={get(examData, 'endDate') ? dayjs(get(examData, 'endDate')) : dayjs()}
                    onChange={(e) => {
                      setExamData({
                        ...examData,
                        endDate: e ? e.toISOString() : null,
                      });
                    }}
                  />
                </Col>
              </Row>
              <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                <Button
                  fullWidth
                  onClick={onCreateOrUpdate}
                  disabled={isDisabled}
                  variant="contained"
                  color="primary"
                >
                  {loading ? <Loading white size={15} /> : null}
                  {data ? 'Update' : 'Create'}
                </Button>
              </Row>
              {has(data, 'id') ? (
                <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                  <Button
                    fullWidth
                    onClick={() => {
                      redirectToBook(examData.bookId);
                    }}
                    disabled={isDisabled}
                    variant="contained"
                    color="primary"
                  >
                    Open book
                  </Button>
                </Row>
              ) : null}
            </Col>
          </Row>
        </ModalConfigArea>
      </ModalContent>
    </Modal>
  );
};



const ListStandardExam = ({ booksAllList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const standardExams = useStandardExams();

  const [loading, setLoading] = useState(false);
  const [examDatam, setExamData] = useState([]);

  const [activeExamData, setActiveData] = useState();
  const [selectedExam, setSelectedExam] = useState();
  const [openEditExamModal, setOpenEditExamModal] = React.useState(false);

  const [openEditExamLevelModal, setOpenEditExamLevelModal] = React.useState(false);
  const [openEditStandardModal, setOpenEditStandardModal] = React.useState(false);

  const [deleteLodaing, setDeleteLoading] = useState(false);
  const [openDeleteExamModal, setOpenDeleteExamModal] = React.useState(false);
  const [activeSession, setActiveSession] = useState(null);
  const [state, setState] = React.useState({
    open: false,
    message: '',
  });
  const loadExams = async () => {
    setLoading(get(standardExams, 'length') == 0);
    await dispatch(handleListStandardExams());
    setLoading(false);
  };

  useEffect(() => {
    loadExams();
  }, []);

  const redirectToBook = (bookId) => {
    navigate(`/add-book?bookId=${bookId}&pageId=1`);
  };
  useEffect(() => {
    //sort exam by order
    if (standardExams) {
      const sortedExams = standardExams.sort((a, b) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      });
      setExamData(sortedExams)
    } else {
      setExamData([])
    }
  }, [standardExams]);


  const handleClose = () => {
    setState({ open: false, message: '' });
  };
  const onAddExam = (exmDt, exm) => {
    setActiveData(exmDt);
    setSelectedExam(exm);
    setOpenEditExamModal(true);
  };
  const onAddEditExamLevel = (exm) => {
    setActiveData(exm);
    setOpenEditExamLevelModal(true);
  };

  const onClose = () => {
    setOpenEditExamModal(false);
    setActiveData(null);
    setSelectedExam(null);
    setOpenEditExamLevelModal(false);
    setOpenEditStandardModal(false);
  };

  const onDeleteExam = async () => {
    setDeleteLoading(true);
    await dispatch(handleDeleteStandardExam(get(activeExamData, 'id')));
    setActiveData(null);
    setOpenDeleteExamModal(false);
    setDeleteLoading(false);
  };



  const { open, message } = state;
  return (
    <Wrapper>
      {loading ? (
        <Loading />
      ) : (
        <>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity="error">
              <strong>ALERT:</strong> {message}
            </Alert>
          </Snackbar>
          <DeleteModal
            deleteToggle={openDeleteExamModal}
            onDelete={onDeleteExam}
            message={`Are you sure you want to delete ${get(activeExamData, 'displayName', 'this standard Exam')}?`}
            setDeleteToggle={() => {
              setOpenDeleteExamModal(false);
            }}
            loading={deleteLodaing}
          />
          <EditExams
            data={selectedExam}
            open={openEditExamModal}
            close={onClose}
            exam={activeExamData}
            booksAllList={booksAllList}
            redirectToBook={redirectToBook}
          />
          <EditStandardExamLevel
            data={activeExamData}
            open={openEditExamLevelModal}
            examDSessionata={examDatam}
            activeSession={activeSession}
            close={onClose}
          />

          <Row style={{ marginTop: '1%' }}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Section
                style={{ fontSize: '18px' }}
                description="exams and standard based exams"
                header="Exams & Standard Based Exams"
              >
                {map(examDatam, (exm) => {
                    const isStandardExam = exm.exam_school === 'standard';
                    return (
                      <LinkArea key={exm.id}>
                        <Row>
                          <Col span={18}>
                            <Button
                              onClick={() => onAddExam(exm)}
                              color="primary"
                              variant="contained"
                            >
                              <Add /> exams
                            </Button>
                            <Button
                              onClick={() => {
                                onAddEditExamLevel(exm);
                              }}
                              color="primary"
                              variant="contained"
                              style={{ marginLeft: '10px' }}
                            >
                              <Edit /> Edit {'Exam Level'}
                            </Button>
                            <Button
                              onClick={() => {
                                setOpenDeleteExamModal(true);
                                setActiveData(exm);
                              }}
                              color="secondary"
                              variant="contained"
                              style={{ marginLeft: '10px' }}
                            >
                              <Delete style={{ color: 'white' }} /> {'Delete Exam Level'}
                            </Button>
                          </Col>
                          <Col span={6}>
                            <span style={{ 
                              display: 'inline-block', 
                              textAlign: 'right', 
                              fontWeight: 600, 
                              fontSize: '14px',
                              padding: '8px 16px',
                              color: '#ffffff',
                              backgroundColor: '#9c27b0',
                              borderRadius: '20px',
                              marginRight: '16px',
                              float: 'right',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                            }}>
                              {exm.displayName || ''}
                            </span>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: '1%' }}>
                          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                            {!exm.standard_exams || exm.standard_exams.length === 0 ? (
                              <div style={{ 
                                textAlign: 'center', 
                                padding: '40px 20px',
                                border: '1px dashed #ddd',
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9'
                              }}>
                                <p style={{ 
                                  fontSize: '16px', 
                                  color: '#666', 
                                  marginBottom: '20px',
                                  fontStyle: 'italic'
                                }}>
                                  No exams found. Add your first exam to get started.
                                </p>
                                <Button
                                  onClick={() => onAddExam(exm)}
                                  color="primary"
                                  variant="contained"
                                >
                                  <Add /> exams
                                </Button>
                              </div>
                            ) : (
                              <List>
                                {map(exm.standard_exams, (obj, i) => (
                                  <ListItem key={obj.id}>
                                    <ExamCover
                                      data={obj}
                                      handleClick={() => onAddExam(exm, obj)}
                                      labelBgColor={isStandardExam ? COLOR.blue : COLOR.redishpink}
                                      label={get(exm, 'displayName')}
                                      exam={exm}
                                      from={'standard'}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            )}
                          </Col>
                        </Row>
                      </LinkArea>
                    );
                  })}
              </Section>
            </Col>
          </Row>
        </>
      )}
    </Wrapper>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(ListStandardExam);
